// useGlobalAgence — expose l'agence sélectionnée globalement (sélecteur topbar)
// Source de vérité : localStorage['cap_global_agence'] + événement 'cap:agence-change'
import { useCallback, useEffect, useState } from 'react';

export const GLOBAL_AGENCE_KEY = 'cap_global_agence';

// Retourne l'id d'agence courant ('all' si aucune sélection globale)
export const getGlobalAgence = () => {
    try {
        return localStorage.getItem(GLOBAL_AGENCE_KEY) || 'all';
    } catch {
        return 'all';
    }
};

// Écrit l'agence globale + notifie toute l'application
export const setGlobalAgence = (v) => {
    const val = v || 'all';
    try {
        if (val === 'all') localStorage.removeItem(GLOBAL_AGENCE_KEY);
        else localStorage.setItem(GLOBAL_AGENCE_KEY, val);
    } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent('cap:agence-change', { detail: val }));
};

// Lecture seule, réactive aux changements (topbar, autre page, autre onglet)
export default function useGlobalAgence() {
    const [agence, setAgence] = useState(getGlobalAgence);

    useEffect(() => {
        const onChange = (e) => setAgence(e?.detail || getGlobalAgence());
        const onStorage = (e) => {
            if (e.key === GLOBAL_AGENCE_KEY) setAgence(getGlobalAgence());
        };
        window.addEventListener('cap:agence-change', onChange);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('cap:agence-change', onChange);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    return agence;
}

// API type useState : [agence, setAgence] synchronisée globalement.
// Permet de remplacer un `useState('all')` de filtre agence sans rien changer d'autre.
export function useGlobalAgenceState() {
    const agence = useGlobalAgence();
    const setAgence = useCallback((v) => setGlobalAgence(v), []);
    return [agence, setAgence];
}
